import { ContainerModule } from 'inversify';
import { PlayerModuleSymbol } from '../api';
import { fetchServiceModule } from './service/di'
import { FetchPlayerModule } from './fetch-player-module'
import { MsgPackCourseFileLoader, MsgPackCourseFileLoaderSymbol } from './msgpack-course-file'

const fetchModule = new ContainerModule((bind) => {
  bind(PlayerModuleSymbol).to(FetchPlayerModule)
  bind(MsgPackCourseFileLoaderSymbol).to(MsgPackCourseFileLoader)
});

export const fetchModules = [
  fetchModule,
  fetchServiceModule
]
